import { render } from "./ModatechWidget.vue?vue&type=template&id=01324c58"
import script from "./ModatechWidget.vue?vue&type=script&lang=js"
export * from "./ModatechWidget.vue?vue&type=script&lang=js"

import "./ModatechWidget.vue?vue&type=style&index=0&id=01324c58&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__